var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row grabjob-view"},_vm._l((_vm.processStats),function(serverStats){return _c('div',{staticClass:"col-md-12"},[_c('server-stats',{key:serverStats._id,attrs:{"stats":serverStats,"process_id":_vm.processId}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c38f6b4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/GrabProcess/View.vue
// module id = kZ6r
// module chunks = 9